module.exports = __webpack_public_path__ + "img/logo.e24d5e7b.png";